<template>
  <ul class="variants">
    <div v-for="(variant, i) in variantList.variants" :key="variant.id">
      <li v-if="variant.aiLoadingPlaceholder" class="ai-loading-placeholder">
        <div v-if="variant.errorMessage" class="text-danger error">
          <span>
            <i class="fa-light fa-exclamation-circle"></i>
          </span>
          <span>
            {{ variant.errorMessage }}
          </span>
          <!-- <div class="error-actions">
            <span
              @click="retryCreateAiVariants(variant, i)"
              :tooltip="$t('ai-variant.regenerate')"
              tooltip-placement="right"
            >
              <i class="fa-light fa-sync-alt"></i>
            </span>
            <span @click="removeAiErrorMessage(i)" :tooltip="$t('cancel')" tooltip-placement="right">
              <i class="fa-light fa-times"></i>
            </span>
          </div> -->
        </div>
        <div v-else>
          <span>
            <i class="fa-light fa-circle-notch fa-spin"></i>
          </span>
          <span>
            {{ $t("ai-variant.loading") }}
          </span>
        </div>
      </li>
      
      <variant
        v-else
        :editorIsActive="variant.editorIsActive"
        :variant="variant"
        :can-convert="variantList.variants.length > 1"
        :showRawHTML="showRawHTML"
        :isDragging="draggingElement"
        @clone-below="createNextVariant(i, variant.text)"
        @add="createNextVariant(i)"
        @remove="({ keepEditing } = {}) => onRemoveVariant(i, keepEditing)"
        @onRemove="onConfirmRemoveVariant(i)"
        @updated="(text) => onVariantUpdated(variant, text)"
        @convert-to-sentence="(selection) => $emit('convert-to-sentence', { variantIndex: i, ...selection })"
        @startDrag="($event, variant, variantRef) => startDrag($event, variant, i, variantList, sentenceId, variantRef)"
        @onDrop="($event, variant) => onDrop($event, variant, i)"
        @dragEnd="handleDragEnd()"
        @ai-rephrase-variant="createAiVariants(variant, i)"
        @ai-translate-variant="translateAivariant(variant, i)"
        :draggingIndex="draggingIndex"
        :variantIndex="i"
      />
    </div>
    <div v-if="!$store.state.showingTemplateBackupInPreview" style="padding-top: 5px">
      <a @click.stop.prevent="createNextVariant(variantList.variants.length)" class="add-variant-btn">
        + {{ $t("sentence.variant") }}
      </a>
    </div>
  </ul>
</template>

<script>
import Variant from "@/components/Variant";
import ConfirmModal from "@/components/modals/ConfirmModal";
import EventBus from "@/assets/js/eventBus.js";
import SynonymHelpers from "@/assets/js/synonymHelpers.js";
export default {
  name: "variants",
  data() {
    return {
      draggingElement: -1,
      draggingIndex: null,
      ghostWidth: null,
      aiErrorOccured: false
    };
  },
  props: {
    variantList: {
      type: Object,
      required: true
    },
    canAdd: {
      type: Boolean
    },
    showRawHTML: {
      type: Boolean,
      default: false
    },
    sentenceId: {
      type: [Number, String]
    }
  },
  methods: {
    startDrag(evt, variant, index, list, sentenceId, variantRef) {
      this.draggingElement = variant.id;
      evt.dataTransfer.effectAllowed = "copyMove";
      evt.dataTransfer.dropEffect = "copyMove";
      evt.dataTransfer.setData("itemIndex", index);
      evt.dataTransfer.setData("variantId", variant.id);

      this.$store.commit("dragVariant", {
        draggedVariant: variant,
        draggedVariantList: list,
        sentenceDraggedFrom: sentenceId
      });
      this.draggingIndex = index;
    },
    onDrop(evt, target, index) {
      this.dragEnded();
      if (evt.dataTransfer.getData("variantId")) {
        const itemIndex = evt.dataTransfer.getData("itemIndex");
        this.draggingElement = -1;
        if (index == 0 && itemIndex == index && evt.dataTransfer.getData("variantId") != target.id) {
          // New variantlist but index 0 is dragged to index 0, so place on top
          this.variantList.add(this.$store.state.draggedVariant.text, 0);
        } else this.variantList.add(this.$store.state.draggedVariant.text, itemIndex > index ? index : index + 1);
        if (!evt.altKey) {
          this.$store.commit("dropVariantInList", itemIndex);
        }
      }
    },
    handleDragEnd() {
      this.dragEnded();
      this.draggingElement = -1;
      this.$store.commit("dragVariantEnded");
    },
    dragEnded() {
      EventBus.$emit("drag-variant-ended");
    },

    onConfirmRemoveVariant(variantIndex) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("variant.delete-variant") + "?",
          confirmButtonText: this.$t("variant.delete"),
          onConfirm: () => this.onRemoveVariant(variantIndex)
        },
        { width: 350, height: "auto" }
      );
    },
    onRemoveVariant(variantIndex, keepEditing) {
      console.log(this.variantList.id);
      let prev = this.variantList.variants[variantIndex - 1];
      let next = this.variantList.variants[variantIndex + 1];
      this.variantList.variants[variantIndex].remove();
      if (keepEditing) {
        if (prev) prev.edit();
        else if (next) next.edit();
      }
      EventBus.$emit("templateChange");
    },
    onVariantUpdated(variant, text) {
      variant.text = text.split("\n").join("");
    },
    createNextVariant(index, text = "") {
      // index is the index after which we want to insert the new variant
      this.variantList.variants.forEach((v) => (v.editorIsActive = false));
      this.$nextTick(() => {
        let newVariant = this.variantList.add(text, index + 1);
        this.$nextTick(() => (newVariant.editorIsActive = true));
        EventBus.$emit("templateChange");
        this.$emit("variant-count", this.variantList.variants.length); // get the amount of variants for parent component in order to make a "global" scenario convert
      });
    },

    retryCreateAiVariants(variant, index) {
      this.removeAiErrorMessage(index);
      this.createAiVariants(variant, index - 1);
    },

    removeAiErrorMessage(index) {
      this.variantList.variants.splice(index, 1);
    },

    removeAiPlaceholdersInList() {
      this.$set(this.variantList, "variants", this.variantList.variants.filter((v) => !v.aiLoadingPlaceholder));
    },

    createAiVariants(variant, index) {
      const data = {
        amount: this.$store.state.autoRephraseVariantAmount,
        variantText: variant.text
      };
      const loadingPlaceholders = [];
      for (let i = 0; i < data.amount; i++) {
        loadingPlaceholders.push({ aiLoadingPlaceholder: true });
      }
      this.variantList.variants.splice(index + 1, 0, ...loadingPlaceholders);

      this.$store
        .dispatch("autoRephraseVariant", data)
        .then((res) => {
          // this.variantList.variants.splice(index + 1, data.amount);
          this.$set(this.variantList, "variants", this.variantList.variants.filter((v) => !v.aiLoadingPlaceholder));
          this.$nextTick(() => {
            this.variantList.addMultipleVariants(res, index + 1);
          });
          EventBus.$emit("templateChange");
        })
        .catch((err) => {
          this.$set(this.variantList, "variants", this.variantList.variants.filter((v) => !v.aiLoadingPlaceholder));
          this.$nextTick(() => {
            this.variantList.variants.splice(index + 1, 0, {
              aiLoadingPlaceholder: true,
              errorMessage: this.$t("ai-variant.error-message"),
              text: variant.text
            });
          });
          setTimeout(() => {
            this.removeAiPlaceholdersInList();
          }, 3000);
        });
    }
  },
  mounted() {
    this.$emit("variant-count", this.variantList.variants.length);
  },
  components: {
    Variant
  }
};
</script>

<style lang="less">
// ul li:last-of-type.active-dropzone-variant{
// 	color: red !important;
// 	// transition: .1s;
// 	transform: translateY(-10px);
// 	padding-bottom: 20px;
// 	}

.variants {
  list-style: none;
  padding-left: 13px !important;
  margin-bottom: 0;

  .add-variant {
    color: #fff;
    &:hover {
      color: var(--text-grey-primary);
    }
  }
  .add-variant-btn {
    cursor: pointer;
    color: var(--orange-web);
    background: rgba(176, 179, 176, 0.144);
    border-radius: 20px;
    padding: 2px 8px;
    box-sizing: border-box;
    display: flex;
    width: max-content;
    &:hover {
      background: #3a4246;
    }
  }

  .ai-loading-placeholder > div {
    width: 100%;
    background-color: #6e757a;
    border-radius: 13px 0 0 13px;
    margin: 4px 0;
    line-height: 24px;
    padding: 2px;
    padding-left: 6px;
    position: relative;
    list-style-type: none;
    display: flex;
    align-items: center;
    gap: 8px;

    &.error {
      background-color: var(--alabaster);
    }

    .error-actions {
      color: var(--charcoal);
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }
}
</style>
